import styled, {css} from 'styled-components';
import {transparentize} from 'polished';
import {DrawerProps} from './types';
import scrollStyles from "helpers/css/scroll";

export const Overlay = styled.div`
  display: grid;
  position: fixed;
  z-index: 9998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  background: ${({theme}) => `
    ${transparentize(.45, theme.colors.black)};
  `};
  
  transition: opacity .3s;
`;

export const Wrapper = styled.div<
  Pick<DrawerProps, 'align'>
>`
  overflow-y: auto;
  position: relative;
  padding-top: 40px;
  padding-left: 40px;
  width: calc(100% - 250px);
  box-sizing: border-box;
  
  ${scrollStyles()}
  
  ${({align}) => {
    switch (align) {
      case 'left': return css`
        margin-right: auto;
        border-radius: 0 20px 20px 0;
      `;
      case 'right': return css`
        margin-left: auto;
        border-radius: 20px 0 0 20px;
      `;
    }
  }};
  
  background: ${({theme}) => `
    ${theme.variables.backgroundColor};
  `};
`;
